import React from "react";
import FadeIn from "../common/FadeIn";

const PasswordWeakSpan = () => {
    return (
      <FadeIn>
      <div className="alert alert-danger pt-3 pb-3" role="alert">
        <span>Password is too weak. Please make sure you password is at least six characters long and has a mix of upper and lower case characters. Add numbers and special characters for greater strength.</span>
      </div>
      </FadeIn>
    );
  }

const PasswordMediumSpan = () => {
    return (
      <FadeIn>
      <div className="alert alert-orange pt-3 pb-3" role="alert">
        <span>Medium strength password.</span>
      </div>
      </FadeIn>
    );
  }

const PasswordStrongSpan = () => {
    return (
      <FadeIn>
      <div className="alert alert-green pt-3 pb-3" role="alert">
        <span>This is a strong password. Well done!</span>
      </div>
      </FadeIn>
    );
  }


const PasswordMismatchSpan = () => {
    return (
      <FadeIn>
      <div className="alert alert-warning pt-3 pb-3" role="alert">
        <span>Password fields don&apos;t match.</span>
      </div>
      </FadeIn>
    );
  }

export {PasswordMismatchSpan, PasswordStrongSpan, PasswordMediumSpan, PasswordWeakSpan }
